import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/filterForm/dateFilter/styles.scss';export default {
  "resourcesFilter": "_resourcesFilter_ymtxb_1",
  "input": "_input_ymtxb_7",
  "toggleArrow": "_toggleArrow_ymtxb_23",
  "selectedResourcesNames": "_selectedResourcesNames_ymtxb_31",
  "name": "_name_ymtxb_40",
  "placeholder": "_placeholder_ymtxb_49",
  "list": "_list_ymtxb_56",
  "item": "_item_ymtxb_70",
  "opened": "_opened_ymtxb_78"
};